/**
 * Whether the organisation's IntelliCatch URL answers. Unknown means there is nothing to probe -
 * no link, or no URL on it - and Checking means the probe is in flight, which is not the same as a
 * failure and must not be reported as one.
 */
export enum IntelliCatchUrlReachability {
  Unknown = 'unknown',
  Checking = 'checking',
  Reachable = 'reachable',
  Unreachable = 'unreachable',
}
